// =============================================================================
// Document Favorite Repository
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

export interface DocFavorite {
  id: string;
  document_id: string;
  document_title: string;
  document_icon: string;
  is_wiki: boolean;
}

export async function fetchDocFavorites(
  userId: string,
  orgId: string
): Promise<DocFavorite[]> {
  const { data, error } = await supabase
    .from('docs_document_favorites')
    .select(`
      id,
      document_id,
      docs_documents!docs_document_favorites_document_id_fkey (title, icon, is_wiki)
    `)
    .eq('user_id', userId)
    .eq('org_id', orgId);

  if (error) {
    console.error('Error fetching doc favorites:', error);
    return [];
  }

  return (data || []).map((row: any) => ({
    id: row.id,
    document_id: row.document_id,
    document_title: row.docs_documents?.title || 'Sans titre',
    document_icon: row.docs_documents?.icon || '📄',
    is_wiki: row.docs_documents?.is_wiki || false,
  }));
}

export async function addDocFavorite(
  userId: string,
  orgId: string,
  documentId: string
): Promise<{ id: string } | null> {
  const { data, error } = await supabase
    .from('docs_document_favorites')
    .insert({ user_id: userId, org_id: orgId, document_id: documentId })
    .select('id')
    .single();

  if (error) {
    console.error('Error adding doc favorite:', error);
    return null;
  }
  return { id: data.id };
}

export async function removeDocFavorite(
  userId: string,
  documentId: string
): Promise<boolean> {
  const { error } = await supabase
    .from('docs_document_favorites')
    .delete()
    .eq('user_id', userId)
    .eq('document_id', documentId);

  if (error) {
    console.error('Error removing doc favorite:', error);
    return false;
  }
  return true;
}
